import { useEffect, useState } from 'react'
import { useApi } from './api'

/**
 * @param {(api: import('./core').API) => Promise<[any, Number, String]>} apiSelector
 */
export function useApiQuery(apiSelector) {
  const api = useApi()

  const [result, setResult] = useState({
    loaded: false,
    data: null,
    status: null,
    error: null
  })
  useEffect(() => {
    if (!api) return

    let cancelled = false
    setResult({
      loaded: false,
      data: null,
      status: null,
      error: null
    })

    async function load() {
      setResult({
        loaded: false,
        data: null,
        status: null,
        error: null
      })

      const [data, status, error] = await apiSelector(api)

      if (!cancelled) {
        setResult({
          loaded: true,
          data: error ? null : data,
          status,
          error: error ? String(error) : null
        })
      }
    }
    load()

    return () => {
      cancelled = true
    }
  }, [api, apiSelector])

  return result
}
